module.exports = __webpack_public_path__ + "img/header-4.c0195b25.jpg";